import { Heading } from 'components/shared/Heading';
import { Texts } from 'components/shared/Texts';
import { FC, useEffect, useState } from 'react';
import { MainTestStrings } from 'utils/strings';
import styles from './MainTestSummary.module.scss';
import { SendEmail } from './SendEmail';
import { SummaryPreview } from './SummaryPreview/SummaryPreview';
import {
  selectExaminationID,
  selectExaminationResult,
} from 'redux/examination/selectors';
import { useAppDispatch, useAppSelector } from 'redux/store';
import instance from 'api/axiosConfig';
import { examinationReportURL } from 'utils/paths';
import { downloadFile } from 'utils/download';
import { Button } from 'components/shared/Button';
import { getExaminationResult } from 'redux/examination/thunks';
import { Summary } from './Summary';
import { LoadingView } from 'components/shared/Loader';
import { useIsExaminationFinished } from 'utils/hooks';
import { ExaminationStatusResponse } from 'api/maintestApi';
import { ErrorPageView } from 'components/modules/Error';
import { REQUEST_DELAY_TIME_MS } from 'utils/validation';

export const MainTestSummary: FC = () => {
  const dispatch = useAppDispatch();

  const examinationId = useAppSelector(selectExaminationID);
  const examinationResult = useAppSelector(selectExaminationResult);
  const examinationFinished = useIsExaminationFinished();

  const [isLoading, setIsLoading] = useState(true);
  useEffect(() => {
    if (!examinationResult) return;

    setTimeout(() => {
      setIsLoading(false);
    }, REQUEST_DELAY_TIME_MS * 2);
  }, [examinationResult]);

  useEffect(() => {
    if (examinationFinished !== ExaminationStatusResponse.finished) return;

    void dispatch(getExaminationResult(examinationId));
  }, [examinationFinished]);

  const downloadPdf = async () => {
    const response = await instance.get<Blob>(
      examinationReportURL(examinationId),
      {
        responseType: 'arraybuffer',
      }
    );
    downloadFile(response, MainTestStrings().Summary.reportName);
  };

  if (examinationFinished === ExaminationStatusResponse.failed)
    return <ErrorPageView errorCode={'ERR_BAD_RESPONSE'} />;

  if (isLoading) return <LoadingView isSummary />;

  return (
    <section className={styles.test_summary}>
      <Heading type="h1" className={styles.summary_header}>
        {MainTestStrings().Summary.header}
      </Heading>
      <section className={styles.summary_buttons}>
        <Heading type="h2" className={styles.summary_buttons_header}>
          {MainTestStrings().Summary.subHeader}
        </Heading>
        <SendEmail />
        <Texts className={styles.buttons_spacer}>{'lub'}</Texts>
        <Button
          className={styles.button_for_pdf}
          onClick={() => void downloadPdf()}
        >
          {MainTestStrings().Summary.button.text}
        </Button>
      </section>
      <SummaryPreview
        header={MainTestStrings().Preview.header}
        resultData={examinationResult}
      />
      <Summary
        header={MainTestStrings().SummarySection.header}
        summary={examinationResult?.summary}
      />
    </section>
  );
};
